(function () {
  'use strict';

  angular.module('wsLrs.services').factory('xsrf', [function () {
    return {
      getHeaders: function getHeaders() {
        // Send a cfg with our xsrf header
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'wsXSRFToken' + "=");
        if (parts.length === 2) {
          return {
            "X-Requested-By": parts.pop().split(";").shift()
          };
        } else {
          return null;
        }
      },
      addHeadersToXhr: function addHeadersToXhr(xhr) {
        _.each(this.getHeaders(), function (headerVal, headerKey) {
          xhr.setRequestHeader(headerKey, headerVal);
        });
      }
    };
  }]);
})();
